import { Link } from "react-router-dom";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function About() {
  useDocumentTitle("关于本站 - 交换朋友的妻子");

  return (
    <div className="bg-background-950 pt-24 md:pt-28 pb-16 md:pb-20">
      <div className="mx-auto max-w-site px-4 md:px-6">
        <nav className="text-xs text-foreground-500 mb-5 flex items-center gap-2">
          <Link to="/" className="hover:text-accent-400 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-300">关于本站</span>
        </nav>

        <header className="max-w-3xl mb-12">
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">关于本站</h1>
          <p className="mt-4 text-sm md:text-base text-foreground-400 leading-relaxed">
            交换朋友的妻子是一个以电影《交换朋友的妻子》为核心的中文影视内容站，面向关注该影片及同类情感、悬疑题材的观众与影评爱好者。
          </p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2 space-y-10">
            <section className="rounded-lg bg-background-900/60 border border-background-800 p-6 md:p-8">
              <h2 className="font-heading text-lg md:text-xl text-foreground-50 flex items-center gap-2 mb-4">
                <span className="w-1 h-5 rounded-full bg-accent-500"></span> 网站定位
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-300 leading-loose">
                <p>
                  我们围绕影片《交换朋友的妻子》整理剧情介绍、演员资料与影片推荐，同时收录了一批主题相近的虚构影视作品，帮助影迷在一次浏览中了解多部影片的剧情脉络。
                </p>
                <p>
                  网站内容以图文为主，所有影片资料均可直接阅读、搜索与分享，方便你在寻找下一部想看的电影时快速获取关键信息。
                </p>
              </div>
            </section>

            <section className="rounded-lg bg-background-900/60 border border-background-800 p-6 md:p-8">
              <h2 className="font-heading text-lg md:text-xl text-foreground-50 flex items-center gap-2 mb-4">
                <span className="w-1 h-5 rounded-full bg-accent-500"></span> 内容范围
              </h2>
              <ul className="space-y-3 text-sm md:text-base text-foreground-300 leading-relaxed">
                {[
                  "电影《交换朋友的妻子》完整剧情介绍与演员资料",
                  "同类型情感、悬疑题材影片的剧情简介与演员信息",
                  "按类型、年代、地区进行筛选与排序的分类浏览",
                  "围绕婚姻、信任与悬疑反转等主题的影片推荐专题",
                  "支持按片名与演员名检索的站内搜索",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-accent-400 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            <section className="rounded-lg bg-background-900/60 border border-background-800 p-6 md:p-8">
              <h2 className="font-heading text-lg md:text-xl text-foreground-50 flex items-center gap-2 mb-4">
                <span className="w-1 h-5 rounded-full bg-accent-500"></span> 使用说明
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-300 leading-loose">
                <p>
                  你可以通过顶部导航在首页、电影分类、相关推荐与关于本站之间切换；在搜索框中输入片名或演员名，即可直达搜索结果页。
                </p>
                <p>
                  详情页的收藏与分享按钮为交互演示，收藏状态刷新后不会保留；本站目前不提供在线播放、下载或购买功能，所有内容仅供浏览参考。
                </p>
              </div>
            </section>
          </div>

          <aside className="space-y-6">
            <div className="rounded-lg bg-background-900/60 border border-background-800 p-6 md:p-8">
              <h2 className="font-heading text-lg text-foreground-50 mb-4">联系我们</h2>
              <p className="text-sm text-foreground-400 leading-relaxed">
                如果你对内容有任何建议、纠错或合作意向，欢迎通过邮件与我们联系。
              </p>
              <a
                href="mailto:hello@exchange-wife.example.com"
                className="mt-5 inline-flex items-center gap-2 w-full justify-center px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
              >
                <i className="ri-mail-send-line"></i> hello@exchange-wife.example.com
              </a>
              <p className="mt-3 text-xs text-foreground-500 text-center">点击后将打开你的邮件客户端</p>
            </div>

            <div className="rounded-lg bg-background-900/60 border border-background-800 p-6 md:p-8">
              <h2 className="font-heading text-lg text-foreground-50 mb-4">内容声明</h2>
              <p className="text-sm text-foreground-400 leading-relaxed">
                本站所展示的影片资料、海报、演员与剧情均为虚构演示内容，仅用于产品展示，与任何真实影片、人物或事件无关。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}